import React, { useCallback, useState, useEffect } from 'react'
import { sanitizeHtml } from '../utils/html'

const withStimulusTextHighlight = (WrappedComponent) => {
  const WithStimulusTextHighlight = (props) => {
    const { dangerouslySetInnerHTML, isHighlightEnabled } = props
    const [HighlightableStimulus, setHighlightableStimulus] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    // Check if highlighting is needed
    const needsHighlighting =
      isHighlightEnabled &&
      dangerouslySetInnerHTML &&
      dangerouslySetInnerHTML.__html

    // Dynamically import HighlightableStimulus to avoid circular dependency
    useEffect(() => {
      if (needsHighlighting && !HighlightableStimulus && !isLoading) {
        setIsLoading(true)
        import(
          '../../../../src/client/assessment/components/Common/HighlightableContent/HighlightableStimulus'
        )
          .then((module) => {
            setHighlightableStimulus(() => module.default)
            setIsLoading(false)
          })
          .catch((error) => {
            console.warn('Failed to load HighlightableStimulus:', error)
            setIsLoading(false)
          })
      }
    }, [needsHighlighting, HighlightableStimulus, isLoading])

    const renderStimulus = useCallback(
      (_props) => {
        const {
          updatedStimulusContent = dangerouslySetInnerHTML?.__html,
          finishedRendering = () => {},
        } = _props || {}

        return (
          <WrappedComponent
            {...props}
            id="highlightable-stimulus-content"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(
                updatedStimulusContent || dangerouslySetInnerHTML?.__html
              ),
            }}
            onFinish={finishedRendering}
          />
        )
      },
      [dangerouslySetInnerHTML?.__html, props]
    )

    if (!needsHighlighting) {
      return <WrappedComponent {...props} />
    }

    if (isLoading || !HighlightableStimulus) {
      return <WrappedComponent {...props} />
    }

    return (
      <HighlightableStimulus stimulus={dangerouslySetInnerHTML.__html}>
        {renderStimulus}
      </HighlightableStimulus>
    )
  }

  return WithStimulusTextHighlight
}

export default withStimulusTextHighlight
